import React, { FC } from "react"
import { AthleticFormGuardianSignatureRequirement, EncryptedGuardianSignature, signatureRequirementLabel } from "../../../models/api-models/guardians/guardian-form-submission"
import { GuardiansListItem } from "./GuardianListItem"
import { useGuardianContext } from "../../../context/GuardianContext"
import { useParams } from "react-router-dom";

export interface GuardiansListProps {
    guardians: EncryptedGuardianSignature[],
    requirement: AthleticFormGuardianSignatureRequirement,
    isCurrentGuardianSinged: boolean,
    isOtherGuardiansSigned: boolean,
    currentGuardianIsActive: boolean
}

export const GuardiansList: FC<GuardiansListProps> = ({ guardians, requirement, isCurrentGuardianSinged, isOtherGuardiansSigned, currentGuardianIsActive }) => {
    const signedGuardians = guardians.filter(g => g.signatureDate && g.isActive);
    const hasSignedGuardians = signedGuardians.length > 0;
    const showSignatureRequirement = requirement !== AthleticFormGuardianSignatureRequirement.None;
    
    return (
        <div className="guardians-list">
            <p className="guardian-block-email">Guardians signed:</p>
            { guardians.length > 0 && (
                <>
                    { signedGuardians.map(guardian => <GuardiansListItem key={guardian.id} guardian={guardian} />) }
                </>
                
            )}
                
            <>
                { !hasSignedGuardians && 
                    (<p className="m-0" style={{ fontSize: '11px', fontStyle: 'italic' }}>None of the guardians have signed the form yet.</p>)
                }
            </>

            { showSignatureRequirement && 
                <span className="guardian-block-email mt-4">* {signatureRequirementLabel[requirement]}</span>
            }
            { isCurrentGuardianSinged && currentGuardianIsActive && 
                <span className="guardian-block-email mt-4">You have signed this form.</span>
            }
            { isOtherGuardiansSigned &&
                <span className="guardian-block-email mt-4">Another guardian has already signed the form.</span>
            }
            { !currentGuardianIsActive && 
                <span style={{ fontSize: '12px', color: '#677294'}} className="mt-4 mb-0">You have been removed from the guardians list. You no longer have permission to sign this form.</span>
            }
        </div>
    )
}